var map = {
	"./glossary.json": 44777,
	"./glossary_BG.json": 76013,
	"./glossary_CS.json": 70796,
	"./glossary_DA.json": 40073,
	"./glossary_DE.json": 43197,
	"./glossary_EL.json": 40247,
	"./glossary_ES.json": 43186,
	"./glossary_ET.json": 65295,
	"./glossary_FI.json": 27635,
	"./glossary_FR.json": 15882,
	"./glossary_GA.json": 81546,
	"./glossary_HR.json": 29640,
	"./glossary_HU.json": 53297,
	"./glossary_IT.json": 65747,
	"./glossary_LT.json": 28362,
	"./glossary_LV.json": 60312,
	"./glossary_MT.json": 44023,
	"./glossary_NL.json": 36612,
	"./glossary_PL.json": 94566,
	"./glossary_PT.json": 86814,
	"./glossary_RO.json": 77461,
	"./glossary_SK.json": 84548,
	"./glossary_SL.json": 93157,
	"./glossary_SV.json": 43459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98638;